const translations = {
    'overlay.hexCount': 'hex count: %d',
    'overlay.instructions': 'Drag to pan • Wheel to zoom • Click a hex',
    'overlay.none': '-',
    'overlay.selected': 'selected: %s',
    'overlay.speed1': '1×',
    'overlay.speed10': '10×',
    'overlay.speed2': '2×',
    'overlay.speed5': '5×',
    'overlay.start': '▶',
    'overlay.stop': '⏹',
    'overlay.zoom': 'zoom: %.2f',
    'overlay.noticeTitle': 'Notifications',
    'overlay.noticeDismiss': 'Dismiss',
    'overlay.noticeFounding': 'Founding expedition → %s',
    'overlay.noticeFoundingDone': 'Founding complete → %s',
    'overlay.noticeFoundingFailed': 'Founding failed → %s',
    'overlay.noticeFoundingFailedDetail': 'Defeated by %s.',
    'overlay.noticeFoundingFailedUnknown': 'unknown enemy',
    'overlay.noticeTransport': 'Transport → %s',
    'overlay.noticeTransportArrived': 'Transport arrived → %s',
    'overlay.noticeScouting': 'Scouts → %s',
    'overlay.noticeScoutingDetails': 'View scouts',
    'overlay.noticeScoutingReturn': 'Scouts returning → %s',
    'overlay.noticeScoutingDone': 'Scouts returned → %s',
    'overlay.noticeBattle': 'Battle → %s',
    'overlay.noticeBattleDone': 'Battle complete → %s',
    'overlay.noticeBattleDetails': 'See details',
    'overlay.noticeBattleReport': 'Battle report → %s',
    'overlay.noticeBattleReportDetail': '%s • Losses %d/%d',
    'overlay.noticeAwaitingOrders': 'Awaiting orders',
    'overlay.alertTitle': 'Alerts',
    'overlay.alertNotControlled': 'Cannot found settlement: region not controlled.',
    'overlay.alertInProgress': 'Founding already in progress for this region.',
    'overlay.alertNoPopulation': 'Cannot found settlement: not enough free population.',
    'overlay.alertNotEnoughResources': 'Cannot found settlement: missing %s.',
    'overlay.alertBuildFailed': 'Cannot build %s: %s.',
    'overlay.alertReasonSlots': 'no building slots available',
    'overlay.alertReasonResources': 'missing %s',
    'overlay.alertReasonFish': 'requires nearby fish',
    'overlay.alertReasonGold': 'requires gold deposit in region',
    'overlay.alertReasonIron': 'requires iron deposit in region',
    'overlay.alertColdWarning': '%s: cold debt %d%%',
    'overlay.alertStarvationWarning': '%s: food supply %.1f hours',
    'overlay.alertDeaths': '%d people died in %s (%s)',
    'overlay.alertCauseStarvation': 'starvation',
    'overlay.alertCauseCold': 'cold',
};

export default translations;
